import {RootStoreState} from '../../../stores/RootStoreState';
import {IProductSubscriptionPlan} from '@wix/wixstores-graphql-schema/dist/src';

export const getSubscriptionPlanList = (rootState: RootStoreState): IProductSubscriptionPlan[] => {
  if (rootState.selectedVariant) {
    return rootState.selectedVariant.subscriptionPlans?.list || [];
  } else {
    return rootState.product.subscriptionPlans?.list || [];
  }
};
